// extracted by mini-css-extract-plugin
export default {"modalMain":"Modal_modalMain__WsQVz","Main":"Modal_Main__xM+j2"};